import {Tabs} from 'antd';
import {checkPerm} from "../../auth/sessionTools";
import {TaskTable} from "../tasks/TaskTable";
import {InventoryTable} from "./InventoryTable";
import {NewPurchaseOrder} from "../sales/NewPurchaseOrder";
import {ExistingPurchaseOrder} from "./ExistingPurchaseOrder";

export const OutsideSalesTab = ({onApiFail, session, refresh, onRefresh, props}) => {
    const hasAllTasks = checkPerm(session, "allTask");

    const items = [
        {
            key: 'Inventory',
            label: 'Inventory',
            children: <InventoryTable onApiFail={onApiFail} refresh={refresh} />
        },
        {
            key: 'NewPurchaseOrder',
            label: 'New Purchase Order',
            children: <NewPurchaseOrder onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'ExistingPurchaseOrder',
            label: 'Existing Purchase Order',
            children: <ExistingPurchaseOrder session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
    ]

    if (hasAllTasks) {
        items.push({
            key: 'DepartmentTasks',
            label: 'Outside Sales Tasks',
            children: <TaskTable refresh={refresh} onApiFail={onApiFail} taskType={'department'} showVerified={false} department={`ff`} />
        });
    }

    return <Tabs tabPosition={'left'} defaultActiveKey={'Inventory'} items={items} />
}